import { environment } from '../../../../../environments/environment';
import { AppConstants } from '../services/api/app-constants';

export const findVendorQueries = {
  query: `
  query findVendorType($vendor_type: String){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVendorDetail}(filter:{
      vendor_type : { eq : $vendor_type}
    })
    {
      items {
        id
        name
        email
        phone
        address
        vendor_type
        is_active
        ex_data
        created_date
        updated_date
      }
      nextToken
    }
  }
  `,
};

export const countriesDataQueries = {
  query: `
  query countries($data_key: String){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listMiscData}(filter: {
      data_key: {eq: $data_key}
    })
    {
      items {
        id
        data_key
        data_value
      }
      nextToken
    }
  }
  `,
};

export const createVendorQueries = {
  mutation: `
  mutation createVendor(
    $name:String
    $email:String
    $phone:String
    $address:String
    $vendor_type:String
    $is_active:String
    $ex_data:String
    $updated_date:String
    $created_date:String
  ) {
    ${AppConstants.create}${environment.dbPrefix}${AppConstants.createOrUpdateCpVendorDetail}(input: {
      name:  $name
      email:$email
      phone:$phone
      address:$address
      vendor_type:$vendor_type
      is_active:$is_active
      ex_data:$ex_data
      updated_date:$updated_date
      created_date:$created_date
    }) {

        id
        name
        email
        phone
        address
        vendor_type
        is_active
        ex_data
        created_date
        updated_date
    }
  }
`,
};

export const updateVendorQueries = {
  mutation: `
  mutation updateVendor(
    $id: ID!,
    $name:String
    $email:String
    $phone:String
    $address:String
    $vendor_type:String
    $is_active:String
    $ex_data:String
    $updated_date:String
    $created_date:String
  ) {
    ${AppConstants.update}${environment.dbPrefix}${AppConstants.createOrUpdateCpVendorDetail}(input: {
      id: $id,
      name:  $name
      email:$email
      phone:$phone
      address:$address
      vendor_type:$vendor_type
      is_active:$is_active
      ex_data:$ex_data
      updated_date:$updated_date
      created_date:$created_date
    }) {

        id
        name
        email
        phone
        address
        vendor_type
        is_active
        ex_data
        created_date
        updated_date
    }
  }
`,
};

export const getVendorQueries = {
  query: `
  query getVendor{
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVendorDetail}
    {
      items {
        id
        name
        email
        phone
        address
        vendor_type
        is_active
        ex_data
        created_date
        updated_date
      }
      nextToken
    }
  }
  `,
};
